import {
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  makeStyles
} from '@material-ui/core';
import MUITextField from '@material-ui/core/TextField';
import { AddCircle, Delete } from '@material-ui/icons';
import FormContext from 'components/Form/FormContext';
import ImageWithDropzone from 'components/Image/ImageWithDropzone';
import { getLanguage } from 'features/app/selectors';
import { onChangeMarketSettingsData } from 'features/MarketSettingContainer/actions';
import { LabelImageThumbnail } from 'features/PpsiContainer/constants';
import React, { useContext, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const useStyles = makeStyles(theme => ({
  tableHeader: {
    background: '#a6c9ec',
    padding: '3px',
    fontWeight: 'bold',
    marginBottom: '5px'
  },
  inputField: {
    padding: '0px',
    width: '100%',
    '& .MuiOutlinedInput-input': {
      padding: '10px !important',
      borderRadius: '0px'
    }
  },
  addButton: {
    float: 'right'
  }
}));
const dataa = [
  {
    id: 'b6e89f98-5d2d-44db-9dcc-475da207bffd',
    code: 'AT111',
    image_id: 'a80506d7-1f0e-42b1-a736-01dc3e8f4c36',
    name: 'SOUP LADLE 12 cl',
    translated_name: 'SOUP LADLE 12 cl',
    status: 'ACTIVE',
    image: {
      downloadUrl:
        'https://admin.ppsidev.net/uploads/26d19b99-cf84-418b-957e-e28a4284ab9e',
      thumbnailUrl:
        'https://admin.ppsidev.net/uploads/thumbnails-26d19b99-cf84-418b-957e-e28a4284ab9e'
    },

    info: {}
  }
];
const FilterButtons = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const language = useSelector(getLanguage);
  const { data, setFieldValue } = useContext(FormContext);
  const [filters, setfilters] = useState(data.filterPPSICoworkerCategory);


  
  

  const onChangeFilterButton = (e, index, key) => {
    const updatedValue = e.target.value;
    const updatedList = filters.map((filterButton, ind) => {
      if (ind === index) {
        return {
          ...filterButton,
          info: {
            ...filterButton.info,
            [language]: {
              ...filterButton.info[language],
              [key]: updatedValue // Dynamically update slug/name
            }
          }
        };
      }
      return filterButton;
    });
    setfilters(updatedList);
    // Sync with form state
    setFieldValue('filterPPSICoworkerCategory', updatedList);
    dispatch(
      onChangeMarketSettingsData({ ...data, filterPPSICoworkerCategory: updatedList })
    );
  };

  const onChangeCheckBox = (e, index) => {
      const updatedValue = e.target.checked;
      const updatedList = filters.map((fil, ind) =>
        ind === index
          ? { ...fil, active: updatedValue, isActive: updatedValue }
          : fil
      );
      setfilters(updatedList);
      setFieldValue('filterPPSICoworkerCategory', updatedList);
      dispatch(onChangeMarketSettingsData({ ...data, filterPPSICoworkerCategory: updatedList }));
    };

  return (
    <div>
      <Grid
        container
        className={classes.tableHeader}
        spacing={2}
        rowSpacing={1}
      >
        <Grid item sm={1} />
        <Grid item sm={4}>
          Name
        </Grid>
        <Grid item sm={5}>
          Translated display text
        </Grid>
        <Grid item sm={1} />
      </Grid>
      {filters && filters.length > 0 &&
        filters.map((item, index) => {
          return (
            <Grid container spacing={2} sx={{ mt: 1 }}>
               <Grid item sm={1}>
                  <FormControlLabel
                    label=""
                    control={
                      <Checkbox
                        // value={code}
                        checked={
                        // defaultSalesPoints.includes(item.code)
                        //   ? true
                        //   :
                        item.isActive
                        }
                        onChange={e => onChangeCheckBox(e, index)}
                        // disabled={defaultSalesPoints.includes(item.code)}
                      />
                    }
                    />
                              {/* {missingLanguages.length > 0 && item.message && (
                                <Tooltip
                                  title={`Sales point name is missing for ${missingLanguages.join(
                                    ', '
                                  )}`}
                                >
                                  <IconButton
                                    style={{ color: '#d11a2a' }}
                                    size="small"
                                    // disabled={isDisable}
                                    // className={classes.addButton}
                                  >
                                    <InfoOutlined />
                                  </IconButton>
                                </Tooltip>
                              )} */}
                            </Grid>
              <Grid item sm={4}>
                <MUITextField
                  // label="Size"
                  id="filled-size-small"
                  defaultValue="Small"
                  variant="outlined"
                  size="small"
                  className={classes.inputField}
                  value={
                    (item.info[language] && item.info[language].slug) || ''
                  }
                  onChange={event => onChangeFilterButton(event, index, `slug`)}
                  disabled
                />
              </Grid>
              <Grid item sm={5}>
                <MUITextField
                  // label="Size"
                  id="filled-size-small"
                  defaultValue="Small"
                  variant="outlined"
                  size="small"
                  className={classes.inputField}
                  value={
                    (item.info[language] && item.info[language].text) || ''
                  }
                  onChange={event => onChangeFilterButton(event, index, `text`)}
                />
              </Grid>
              {/* <Grid item sm={1}>
                {item.id === '' && (
                  <IconButton
                    onClick={() => onDeleteFilterButton(index)}
                    style={{ color: '#d11a2a' }}
                    size="small"

                    // disabled={isDisable}
                  >
                    <Delete />
                  </IconButton>
                )}
                {index === filters.length - 1 && (
                  <IconButton
                    onClick={addFilterButton}
                    color="secondary"
                    size="small"
                    // disabled={isDisable}
                    className={classes.addButton}
                  >
                    <AddCircle />
                  </IconButton>
                )}
              </Grid> */}
            </Grid>
          );
        })}
    </div>
  );
};

export default FilterButtons;
